import React from 'react';
import { company } from '../mock';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-serif text-2xl md:text-3xl mb-4">{title}</h2>
    <div className="text-black/75 leading-relaxed space-y-3">{children}</div>
  </section>
);

const Privacy = () => {
  return (
    <div className="pt-[72px] bg-white">
      <section className="bg-black text-white py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">Légal</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-3">Politique de confidentialité</h1>
        </div>
      </section>

      <article className="py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 text-[15px]">
          <p className="text-black/60 mb-10">
            Ha Transport SARL (« nous ») s'engage à protéger la vie privée des utilisateurs du site
            <strong> hatransport.fr</strong>. Cette politique décrit les données collectées, leur usage et
            vos droits, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
            « Informatique et Libertés » du 6 janvier 1978 modifiée.
          </p>

          <Section title="1. Responsable du traitement">
            <p>
              <strong>Ha Transport SARL</strong> — {company.address}<br />
              SIRET : 852 154 970 00010 — RCS 852 154 970<br />
              Téléphone : {company.phone}<br />
              E-mail : <a className="underline" href={`mailto:${company.email}`}>{company.email}</a>
            </p>
          </Section>

          <Section title="2. Données collectées">
            <p>Lors de votre utilisation du site, nous pouvons collecter :</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li><strong>Identité</strong> : nom, prénom</li>
              <li><strong>Coordonnées</strong> : adresse e-mail, numéro de téléphone</li>
              <li><strong>Données de réservation</strong> : adresses de prise en charge et destination, date, heure, type de véhicule, nombre de passagers et bagages</li>
              <li><strong>Données techniques</strong> : préférence de langue (cookie technique), brouillon de réservation (localStorage)</li>
            </ul>
            <p>Nous ne collectons aucune donnée bancaire via le site (le paiement étant effectué en présentiel ou via virement).</p>
          </Section>

          <Section title="3. Finalités du traitement">
            <p>Vos données sont utilisées exclusivement pour :</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Répondre à votre demande de devis ou de réservation</li>
              <li>Exécuter la prestation de transport convenue</li>
              <li>Vous tenir informé en cas de changement (retard, etc.)</li>
              <li>Établir la facturation et respecter nos obligations légales</li>
            </ul>
          </Section>

          <Section title="4. Base légale">
            <p>
              Le traitement repose sur votre <strong>consentement</strong> (formulaire de contact), sur
              l'<strong>exécution d'un contrat</strong> (prestation de transport) ou sur le respect d'une
              <strong> obligation légale</strong> (comptabilité).
            </p>
          </Section>

          <Section title="5. Destinataires">
            <p>
              Vos données ne sont communiquées qu'aux personnes habilitées au sein de Ha Transport et,
              le cas échéant, à nos prestataires de confiance (expert-comptable, hébergeur). Aucune donnée
              n'est revendue à des tiers ni utilisée à des fins commerciales externes.
            </p>
          </Section>

          <Section title="6. Durée de conservation">
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Données de contact / réservation : 3 ans après le dernier contact</li>
              <li>Données de facturation : 10 ans (obligation légale)</li>
              <li>Cookies techniques / localStorage : jusqu'à effacement par l'utilisateur</li>
            </ul>
          </Section>

          <Section title="7. Vos droits">
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Droit d'<strong>accès</strong> à vos données</li>
              <li>Droit de <strong>rectification</strong></li>
              <li>Droit à l'<strong>effacement</strong> (« droit à l'oubli »)</li>
              <li>Droit à la <strong>limitation</strong> du traitement</li>
              <li>Droit à la <strong>portabilité</strong> de vos données</li>
              <li>Droit d'<strong>opposition</strong></li>
            </ul>
            <p>
              Pour exercer ces droits, contactez-nous à
              <a className="underline ml-1" href={`mailto:${company.email}`}>{company.email}</a> avec
              un justificatif d'identité.
            </p>
            <p>
              Vous disposez également du droit d'introduire une réclamation auprès de la CNIL
              (www.cnil.fr) si vous estimez que vos droits ne sont pas respectés.
            </p>
          </Section>

          <Section title="8. Cookies">
            <p>
              Le site n'utilise que des <strong>cookies techniques strictement nécessaires</strong> à son
              fonctionnement :
            </p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li><code>ha_lang</code> : mémorise la langue choisie (FR/EN)</li>
              <li><code>ha_booking_draft</code> : conserve temporairement votre brouillon de réservation</li>
            </ul>
            <p>
              Aucun cookie publicitaire ou de suivi tiers (Google Analytics, Facebook Pixel, etc.) n'est
              déposé sur ce site.
            </p>
          </Section>

          <Section title="9. Sécurité">
            <p>
              Nous mettons en œuvre toutes les mesures techniques et organisationnelles raisonnables pour
              protéger vos données contre tout accès non autorisé, perte, altération ou divulgation
              (HTTPS/SSL, accès restreint, sauvegardes).
            </p>
          </Section>

          <Section title="10. Modifications">
            <p>
              Cette politique de confidentialité peut être mise à jour à tout moment. La date de dernière
              mise à jour figure ci-dessous.
            </p>
          </Section>

          <p className="text-xs text-black/50 mt-12">Dernière mise à jour : mai 2026</p>
        </div>
      </article>
    </div>
  );
};

export default Privacy;
